import React from "react";
// @mui/icons-material
import Check from "@mui/icons-material/Check";
import Warning from "@mui/icons-material/Warning";
// core components
import SnackbarContent from "/components/Snackbar/SnackbarContentTribalism.js";
import Clearfix from "/components/Clearfix/Clearfix.js";

import Link from "next/link";
import Button from "components/CustomButtons/Button.js";

export default function SectionNotifications() {
  return (
    <div>
      <SnackbarContent
        message={
          <span>
            <b>📣&nbsp;&nbsp;&nbsp;&nbsp;Announcement: </b>Next GA4 Training
            Session 2023-11-15. For more info click here:
            <Link href="/services/training/google-analytics-training">
              <Button color="rose" size="sm" style={{ marginLeft: "20px" }}>
                More Info
              </Button>
            </Link>{" "}
          </span>
        }
        close
        color="info"
        //icon="info_outline"
      />

      <Clearfix />
    </div>
  );
}
